import { useState } from "react";
import emailjs from "@emailjs/browser";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);

    const templateParams = {
      name,
      email,
      message,
    };

    emailjs
      .send(
        "service_qmbn0wi",
        "template_zg8lttf",
        templateParams,
        "fIkHZBH5assDXC6wW"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Thank you. We have received your message.");
          clearState();
        },
        (error) => {
          console.log("Error", error.text);
          alert(
            "Sorry. Message failed. Please send email to help@cradle-ai.com"
          );
        }
      );
  };

  return (
    // <div>
    //   <div id="contact">
    //     <div className="container">
    //       <div className="col-md-8">
    //         <div className="row">
    //           <div className="section-title">
    //             <h2>Get In Touch</h2>
    //             <p>
    //               Please fill out the form below to send us an email and we will
    //               get back to you as soon as possible.
    //             </p>
    //           </div>
    //           <form name="sentMessage" validate onSubmit={handleSubmit}>
    //             <div className="row">
    //               <div className="col-md-6">
    //                 <div className="form-group">
    //                   <input
    //                     type="text"
    //                     id="name"
    //                     name="name"
    //                     className="form-control"
    //                     placeholder="Name"
    //                     required
    //                     value={name}
    //                     onChange={handleChange}
    //                   />
    //                   <p className="help-block text-danger"></p>
    //                 </div>
    //               </div>
    //               <div className="col-md-6">
    //                 <div className="form-group">
    //                   <input
    //                     type="email"
    //                     id="email"
    //                     name="email"
    //                     className="form-control"
    //                     placeholder="Email"
    //                     required
    //                     value={email}
    //                     onChange={handleChange}
    //                   />
    //                   <p className="help-block text-danger"></p>
    //                 </div>
    //               </div>
    //             </div>
    //             <div className="form-group">
    //               <textarea
    //                 name="message"
    //                 id="message"
    //                 className="form-control"
    //                 rows="4"
    //                 placeholder="Message"
    //                 required
    //                 value={message}
    //                 onChange={handleChange}
    //               ></textarea>
    //               <p className="help-block text-danger"></p>
    //             </div>
    //             <div id="success"></div>
    //             <button type="submit" className="btn btn-custom btn-lg">
    //               Send Message
    //             </button>
    //           </form>
    //         </div>
    //       </div>
    //       <div className="col-md-3 col-md-offset-1 contact-info">
    //         <div className="contact-item">
    //           {/* <h3>Contact Info</h3> */}
    //           <h3></h3>
    //           <p style={{ fontSize: "16px" }}>
    //             <span>
    //               <i className="fa fa-map-marker"></i> Address
    //             </span>
    //             {props.data ? props.data.address : "loading"}
    //           </p>
    //         </div>
    //         {/* <div className="contact-item">
    //           <p>
    //             <span>
    //               <i className="fa fa-phone"></i> Phone
    //             </span>{" "}
    //             {props.data ? props.data.phone : "loading"}
    //           </p>
    //         </div> */}
    //         <div className="contact-item">
    //           <p style={{ fontSize: "16px" }}>
    //             <span>
    //               <i className="fa fa-envelope-o"></i> Email
    //             </span>{" "}
    //             {props.data ? props.data.email : "loading"}
    //           </p>
    //         </div>
    //         <div className="col-md-12">
    //           <div className="row">
    //             <div className="social">
    //               <ul
    //                 style={{
    //                   listStyle: "none",
    //                   display: "flex",
    //                   justifyContent: "center",
    //                 }}
    //               >
    //                 <li>
    //                   <a href={props.data ? props.data.linkedin : "/"}>
    //                     <i className="fa fa-linkedin"></i>
    //                   </a>
    //                 </li>
    //                 <li>
    //                   <a href={props.data ? props.data.facebook : "/"}>
    //                     <i className="fa fa-facebook"></i>
    //                   </a>
    //                 </li>
    //                 <li>
    //                   <a href={props.data ? props.data.twitter : "/"}>
    //                     <i className="fa fa-twitter"></i>
    //                   </a>
    //                 </li>
    //                 {/* <li>
    //                   <a href={props.data ? props.data.youtube : "/"}>
    //                     <i className="fa fa-youtube"></i>
    //                   </a>
    //                 </li> */}
    //               </ul>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       {/* <div className="col-md-12">
    //         <div className="row">
    //           <div className="social">
    //             <ul>
    //               <li>
    //                 <a href={props.data ? props.data.linkedin : "/"}>
    //                   <i className="fa fa-linkedin"></i>
    //                 </a>
    //               </li>
    //               <li>
    //                 <a href={props.data ? props.data.facebook : "/"}>
    //                   <i className="fa fa-facebook"></i>
    //                 </a>
    //               </li>
    //               <li>
    //                 <a href={props.data ? props.data.twitter : "/"}>
    //                   <i className="fa fa-twitter"></i>
    //                 </a>
    //               </li>
    //               <li>
    //                 <a href={props.data ? props.data.youtube : "/"}>
    //                   <i className="fa fa-youtube"></i>
    //                 </a>
    //               </li>
    //             </ul>
    //           </div>
    //         </div>
    //       </div> */}
    //     </div>
    //   </div>
    //   {/* <div id="footer">
    //     <div className="container text-center">
    //       <p>
    //         &copy; 2023 Issaaf Kattan React Land Page Template. Design by{" "}
    //         <a href="http://www.templatewire.com" rel="nofollow">
    //           TemplateWire
    //         </a>
    //       </p>
    //     </div>
    //   </div> */}
    // </div>
    <div>
      <div id="contact">
        <div className="container contact-shell">
          <div className="row contact-content-row">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Send us a message and we will get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Send Message
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>
                Contact Info
              </h3>
              <p>
                <span>
                  <span className="contact-symbol" aria-hidden="true">
                    <svg viewBox="0 0 24 24" role="img" focusable="false">
                      <path
                        d="M12 21s6-5.7 6-11a6 6 0 1 0-12 0c0 5.3 6 11 6 11Z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle cx="12" cy="10" r="2.2" fill="currentColor" />
                    </svg>
                  </span>
                  Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <span className="contact-symbol" aria-hidden="true">
                    <svg viewBox="0 0 24 24" role="img" focusable="false">
                      <path
                        d="M7.8 4.8h2.7l1.3 3.3-1.6 1.8a14 14 0 0 0 4 4l1.8-1.6 3.3 1.3v2.7a1.6 1.6 0 0 1-1.7 1.6A13.8 13.8 0 0 1 6.2 6.5a1.6 1.6 0 0 1 1.6-1.7Z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <span className="contact-symbol" aria-hidden="true">
                    <svg viewBox="0 0 24 24" role="img" focusable="false">
                      <rect
                        x="4"
                        y="6.5"
                        width="16"
                        height="11"
                        rx="2"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />
                      <path
                        d="m5.5 8 6.5 5 6.5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
          </div>
          <div className="row contact-footer-row">
          <div className="col-md-12">
              <div className="social">
                <ul>
                  <li>
                    <div className="footer-left">
                      <span style={{ color: "white" }}>© 2025 CradleAI</span>
                      <span className="footer-separator" aria-hidden="true">
                        {" | "}
                      </span>
                      <a
                        style={{ color: "white" }}
                        href="#/termsnconditions"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Terms of Use
                      </a>
                      <span className="footer-separator" aria-hidden="true">
                        {" | "}
                      </span>
                      <a
                        style={{ color: "white" }}
                        href="#/privacypolicy"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                      </a>
                    </div>
                  </li>
                  <li>
                    <a
                      href={props.data ? props.data.facebook : "/"}
                      className="social-link"
                      aria-label="Facebook"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/img/socialmedia/facebook.png`}
                        alt=""
                        aria-hidden="true"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href={props.data ? props.data.twitter : "/"}
                      className="social-link"
                      aria-label="X"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/img/socialmedia/twitter.png`}
                        alt=""
                        aria-hidden="true"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href={props.data ? props.data.linkedin : "/"}
                      className="social-link"
                      aria-label="LinkedIn"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/img/socialmedia/linkedin.png`}
                        alt=""
                        aria-hidden="true"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href={props.data ? props.data.instagram : "/"}
                      className="social-link"
                      aria-label="Instagram"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/img/socialmedia/social.png`}
                        alt=""
                        aria-hidden="true"
                      />
                    </a>
                  </li>
                </ul>
              </div>
          </div>
          </div>
        </div>
      </div>

      {/* <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2023 Issaaf Kattan React Land Page Template. Design by{" "}
            <a href="http://www.templatewire.com" rel="nofollow">
              TemplateWire
            </a>
          </p>
        </div>
      </div> */}
    </div>
  );
};
